module.exports = __webpack_public_path__ + "img/微信图片_20241203085622.c80e0cce.jpg";